import React from "react";
import { useSearchParams } from "react-router";
import { useGetFileDetailsQuery } from "@/api/files";
import { DriveBasePage } from "@/views/drive/driveBasePage";
import { useDriveList } from "./hooks/use-drive-list";
import { useDriveSearch } from "./hooks/use-drive-search";

export const RootDriveView: React.FC = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get("q");

  if (query) {
    return <RootDrivePageSearch query={query} />;
  } else {
    return <RootDrivePageDefault />;
  }
};

const RootDrivePageDefault = () => {
  const { isLoading, error, displayItems, totalPages, setCurrentPage, itemsPerPage, currentPage, data } =
    useDriveList();

  return (
    <DriveBasePage
      totalPages={totalPages}
      setCurrentPage={setCurrentPage}
      itemsPerPage={itemsPerPage}
      currentPage={currentPage}
      isLoading={isLoading}
      error={error}
      displayItems={displayItems}
      isRootDirectory={true}
      data={data}
    />
  );
};

interface RootDrivePageSearchProps {
  query: string;
}

const RootDrivePageSearch: React.FC<RootDrivePageSearchProps> = ({ query }) => {
  const { isLoading, error, displayItems, totalPages, setCurrentPage, itemsPerPage, currentPage } = useDriveSearch({
    query,
    entry_type: ["file"],
  });
  const { data, isLoading: isLoadingDetails } = useGetFileDetailsQuery({});

  return (
    <DriveBasePage
      totalPages={totalPages}
      setCurrentPage={setCurrentPage}
      itemsPerPage={itemsPerPage}
      currentPage={currentPage}
      isLoading={isLoading || isLoadingDetails}
      error={error}
      displayItems={displayItems}
      isRootDirectory={true}
      data={data}
    />
  );
};
